import script from "./PanelLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelLayout.vue?vue&type=script&setup=true&lang=js"

import "./PanelLayout.vue?vue&type=style&index=0&id=35ecc29e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ecc29e"]])

export default __exports__